import { configureStore } from 'redux-starter-kit';
import sessionReducer from './reducers/session';
import rootReducer from './reducers/reducers';

const store = configureStore({
  reducer: { root: rootReducer, session: sessionReducer }
});

export default store;



// WEBPACK FOOTER //
// ./src/Store.js